<template>
	<div>
		<div class="content">
			<div class="item">
				<input type="text" v-model="oldPwd" placeholder="Old password">
			</div>
			
			<div class="item">
				<input type="text" v-model="pwd" placeholder="New Password">
			</div>
			<div class="item">
				<input type="text" v-model="ensurePassword" placeholder="Confirm New Password">
			</div>
			<div class="edit_btn" @click="submit">submit</div>
		</div>
		
	</div>
</template>

<script>
	export default{
		data(){
			return{
				pwd:'',
				oldPwd:'',
				ensurePassword:''
			}
		},
		methods:{
			submit(){
				var params = {
					newpassword:this.pwd,
					oldpassword:this.oldPwd
				}
				this.$api.post('user/savepassword',params,res=>{
					if(res.code == 1){
						this.$message({
							showClose:true,
							duration:0,
							message:'Successful'
						})
						this.$router.go(-1)
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.content{
		width: 800px;
		margin: 0 auto;
		.item{
			width: 100%;
			height: 80px;
			border: 1px solid #282E30;
			border-radius: 10px;
			margin-top: 30px;
			padding-left: 30px;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: #999999;
			line-height: 80px;
			input{
				width: 100%;
				font-size: 20px;
				line-height: 40px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #999999;
			}
		}
		.code_box{
			width: 100%;
			margin-top: 30px;
			input{
				width: 580px;
				height: 80px;
				border: 1px solid #282E30;
				border-radius: 10px;
				margin-top: 30px;
				padding-left: 30px;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #999999;
				line-height: 80px;
				margin-top: 0;
			}
			.code{
				width: 190px;
				height: 80px;
				background: #5C707A;
				border-radius: 10px;
				text-align: center;
				line-height: 80px;
				font-size: 24px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #F7F2EB;
				cursor: pointer;
			}
		}
		.edit_btn{
			width: 181px;
			height: 57px;
			background: #5C707A;
			border-radius: 29px;
			margin: 0 auto;
			margin-top: 40px;
			line-height: 57px;
			text-align: center;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #F7F2EB;
			cursor: pointer;
		}
	}
	
</style>